// @flow
import { createSelector, createStructuredSelector } from 'reselect';
import { selectors as projectBuilder } from '../../../../../duck';

// type FormValues = {
//     needsApproval: boolean,
//     twoWayRatingEnabled: boolean,
// };

export const getInitialValues = createSelector(
    // $FlowIssue weird error message - could be a bug in flow or reselect typedef
    projectBuilder.getInitialValues,
    createStructuredSelector({
        needsApproval: (values: Object) => values.needsApproval,
        needsPublicWorkforce: (values: Object) => values.needsPublicWorkforce,
        twoWayRatingEnabled: (values: Object) => values.twoWayRatingEnabled,
    })
);

export default {
    getInitialValues,
};
